const projectsArray = [
  {
    id: 1,
    name: 'Classroom',
  },
  {
    id: 2,
    name: 'Foundation',
  },
  {
    id: 3,
    name: 'Little Genie',
  },
  {
    id: 7,
    name: 'Open School',
  },
  {
    id: 5,
    name: 'Personal Mentor',
  },
  {
    id: 8,
    name: 'SkillX',
  },
  {
    id: 4,
    name: 'Speak Pro',
  },
  {
    id: 6,
    name: 'Vacation Course',
  },
];

export const wingProjectPiviotTableHeader = [
  {
    field: 'wingName',
    headerName: 'Team',
    width: 150,
  },
  ...projectsArray.map(({ id, name }) => ({
    field: name,
    headerName: name,
    width: 150,
    align: 'center',
    headerAlign: 'center',
    renderCell: ({ row }) => row.projects?.[id],
  })),
];
